import * as yup from 'yup';

// https://github.com/jquense/yup/blob/master/docs/typescript.md
// https://github.com/jquense/yup/issues/312

yup.addMethod<yup.ArraySchema<yup.AnySchema>>(
  yup.array,
  'emailList',
  function () {
    return this.transform(function (value: string, originalValue: string) {
      if (this.isType(value) && value !== null) {
        return value;
      }
      return originalValue ? originalValue.split(/[\s;]+/) : [];
    }).of(yup.string().email(({ value }) => `${value} is not a valid email`));
  },
);

export default yup;
